import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class ClockEvent extends DomainObject {
  @observable eventType;
  @observable createdAt;
  @observable location;

  @observable projectId;
  @observable projectName;
  @observable note;
}

export default ClockEvent;
